// src/utils/studentLogin.js
//
// Students made by an educator or admin (AdminRoles / createUserWithStudents)
// sign in with a made-up address like  timmy01-572830@sbl.school . Nobody can
// receive mail there, so they can never click a "confirm your email" link —
// and every page that waited for a confirmed email locked them out.
//
// Those addresses are created only by staff, so they count as confirmed:
//   * here, for every screen that checks (isEmailConfirmed), and
//   * on the server, which marks the Auth account verified as soon as it is
//     created (functions/studentAccounts.js).

export const SYNTHETIC_STUDENT_DOMAIN = "@sbl.school";

export const isSyntheticStudentEmail = (email) => String(email || "").trim().toLowerCase().endsWith(SYNTHETIC_STUDENT_DOMAIN);

/** A Firebase user counts as confirmed if they verified, or are a staff-made student login. */
export const isEmailConfirmed = (user) => Boolean(user && (user.emailVerified || isSyntheticStudentEmail(user.email)));
